import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=816e3c6a&scoped=true"
import script from "./BasicInformation.vue?vue&type=script&lang=js"
export * from "./BasicInformation.vue?vue&type=script&lang=js"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=816e3c6a&prod&scoped=true&lang=css"
import style1 from "./BasicInformation.vue?vue&type=style&index=1&id=816e3c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816e3c6a",
  null
  
)

export default component.exports